const EMAIL =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const TEL = /^(\+{0,1}([0-9]{3,5}((\-{0,1})([0-9]{1,12})$)))/;
const SPACE = / /g;
const PID = /^[0-9]{6}[-+AaBbCcDdEeFfYXxWwVvUu][0-9]{3}[0-9A-Ya-y]$/;
const PID_VALIDATION_CHARACTERS = {
  0: '0',
  1: '1',
  2: '2',
  3: '3',
  4: '4',
  5: '5',
  6: '6',
  7: '7',
  8: '8',
  9: '9',
  10: 'A',
  11: 'B',
  12: 'C',
  13: 'D',
  14: 'E',
  15: 'F',
  16: 'H',
  17: 'J',
  18: 'K',
  19: 'L',
  20: 'M',
  21: 'N',
  22: 'P',
  23: 'R',
  24: 'S',
  25: 'T',
  26: 'U',
  27: 'V',
  28: 'W',
  29: 'X',
  30: 'Y',
};

export const validateTelephone = (phone: string) => {
  if (!phone.length) {
    return false;
  }
  const input = phone.replace(SPACE, '');
  return TEL.test(input);
};

export const validateEmail = (email: string) => {
  if (!email.length) {
    return false;
  }
  return EMAIL.test(email);
};

export const validatePersonalIdentificationNumber = (pid: string) => {
  if (pid.length !== 11) {
    return false;
  }
  if (!PID.test(pid)) {
    return false;
  }

  const dateNumbers = pid.substring(0, 6);
  const individualNumber = pid.substring(7, 10);
  const validationCharacter = pid[10].toUpperCase();

  // (This is not checked in Kipinä side, so commenting it out here also)
  // Numbers 000, 001 and 900–999 are not used in normal PIDs
  // if (UNUSED_PID_INDIVIDUAL_NUMBERS.includes(parseInt(individualNumber, 10))) {
  //  return false;
  // }

  // Checking date validity has been disable intentionally, since the date is not always valid...
  //
  // "Henkilötunnuksissa on sallittu myös muita kuin todellisia kalenteripäiväyksiä: ainakin 29.2. ja 30.2.,
  // kun syntymävuosi ≤ 1967 (Lähde: VRK:n systeemisuunnitelma 1974). Ilmeisesti tällaisia päiväyksiä on
  // esiintynyt virallisissa väestörekisteriasiakirjoissa. Ei ole tiedossa, kuinka laajasti virheellisiä
  // päiväyksiä on tunnuksissa ollut ja onko virheet sittemmin korjattu."
  // - https://www.tuomas.salste.net/doc/tunnus/henkilotunnus.html#syntymapv
  //
  // const middleSign = pid[7];
  // const yearStartDigits = middleSign === '+' ? '18' : middleSign === '-' ? '19' : '20';
  // const fullYearDigits = `${yearStartDigits}${dateNumbers.substring(4,6)}`;
  // const dateDigitsWithFullYear = `${dateNumbers.substring(0, 4)}${fullYearDigits}`
  // if (!moment(dateDigitsWithFullYear, 'DDMMYYYY').isValid()) {
  //  return false;
  // }

  const validationCharacterOK = (dateNumbers: string, individualNumber: string, validationCharacter: string) => {
    const pidAsNumber = parseInt(dateNumbers + individualNumber, 10);
    if (isNaN(pidAsNumber)) return false;
    const calculatedValidationCharacter =
      PID_VALIDATION_CHARACTERS[(pidAsNumber % 31) as keyof typeof PID_VALIDATION_CHARACTERS];
    return calculatedValidationCharacter === validationCharacter;
  };

  return validationCharacterOK(dateNumbers, individualNumber, validationCharacter);
};

export default {
  validateTelephone,
  validateEmail,
  validatePersonalIdentificationNumber,
};
